import {
  DevicesResponse,
  TriggersResponse,
} from "@asantech/common/asantech-client";
import client, { AxiosRequestConfig } from "api/client";
import { ApiEndpoints, triggerMapping } from "api/endpoints";
import {
  Lane,
  LaneInput,
  LaneStats,
  TriggerMappingRequest,
  TriggerMappingResponse,
} from "../../../backend/src/lanes/types";

type LanesQueryParams = { hallId: string };

export function getLanes(hallId: string) {
  const params: LanesQueryParams = {
    hallId,
  };
  return client.get<Lane[]>(ApiEndpoints.Lanes, { params });
}

export function getLanesStats(fromDate: Date) {
  const queryParams = `?fromDate=${encodeURIComponent(fromDate.toISOString())}`;
  return client.get<LaneStats[]>(`${ApiEndpoints.LanesStats}${queryParams}`);
}

export function getNotifiers() {
  return client.get<string[]>(ApiEndpoints.Notifiers);
}

export function getDevices() {
  return client.get<DevicesResponse>(ApiEndpoints.Devices);
}

export function getDeviceTriggers(deviceId: string) {
  return client.get<TriggersResponse>(
    `${ApiEndpoints.DeviceTriggers}?deviceId=${deviceId}`
  );
}

export async function setTriggerMapping(
  laneId: string,
  input: TriggerMappingRequest
) {
  const response = await client.post<TriggerMappingResponse>(
    triggerMapping(laneId),
    input
  );
  return response.data;
}

export function getTriggerMapping(laneId: string) {
  return client.get<TriggerMappingResponse>(triggerMapping(laneId));
}

export async function createLane(laneData: LaneInput) {
  return client.post<Lane>(ApiEndpoints.Lanes, laneData);
}

export async function deleteLane(laneId: string) {
  return client.delete(`${ApiEndpoints.Lanes}/${laneId}`);
}

export async function updateLane(laneId: string, laneData: LaneInput) {
  return client.patch<Lane>(`${ApiEndpoints.Lanes}/${laneId}`, laneData);
}

export async function updateLanesOrder(
  lanesOrder: string[],
  config: Partial<AxiosRequestConfig> = {}
) {
  return client.put<Lane>(ApiEndpoints.LanesOrder, lanesOrder, config);
}
